module.exports = __webpack_public_path__ + "img/2.76ca66af.jpg";